import { render, staticRenderFns } from "./DebtorInfo.vue?vue&type=template&id=c7e8dd5e&scoped=true"
import script from "./DebtorInfo.vue?vue&type=script&lang=ts"
export * from "./DebtorInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7e8dd5e",
  null
  
)

export default component.exports